// offsets the target element's position when using on-page scroll nav

// Constants and Global Variables
const secondaryNavSelector = '.secondary-nav';
const primaryNavSelector = '.main-nav';
const mobileScrollNavWrapperSelector = '.scroll-nav-wrapper-mobile';
const desktopScrollNavWrapperSelector = '.scroll-nav-wrapper .sticky-top';

let totalNavHeight: number;


// determine the height of the nav, and set the top position of the scroll nav
function updateNavHeight(): number {
    const secondaryNavElement = document.querySelector(secondaryNavSelector);
    const primaryNavElement = document.querySelector(primaryNavSelector);

    const secondaryNavHeight: number = secondaryNavElement ? secondaryNavElement.getBoundingClientRect().height : 0;
    const primaryNavHeight: number = primaryNavElement ? primaryNavElement.getBoundingClientRect().height : 0;

    let totalNavHeight = window.innerWidth < 1200 ? secondaryNavHeight : primaryNavHeight;

    setElementTop(mobileScrollNavWrapperSelector, totalNavHeight - 2);
    setElementTop(desktopScrollNavWrapperSelector, totalNavHeight + 16);

    return totalNavHeight;
}

function setElementTop(selector: string, value: number): void {
    const element = document.querySelector(selector) as HTMLElement;
    if (element) {
        element.style.top = `${value}px`;
    }
}

function broadcastNavHeight(): void {
    const event = new CustomEvent('navHeightUpdated', { detail: totalNavHeight });
    document.dispatchEvent(event);
}

function handleNavLinkClick(offsets: { default: number, overview: number }) {
    return function(event: Event) {
        event.preventDefault();

        const targetId = (event.currentTarget as HTMLAnchorElement).getAttribute('href');
        if (!targetId) return;

        const targetElement = document.querySelector(targetId) as HTMLElement;
        if (!targetElement) return;

        let offsetTop = totalNavHeight + offsets.default;
        if (targetId === "#overview" && targetElement.classList.contains('has-mandatory')) {
            offsetTop = totalNavHeight + offsets.overview;
        }

        // Simulate a click on the accordion button
        const accordionBtn = document.querySelector('[data-bs-target="#scroll-nav-mobile-accordion"]');
        if (accordionBtn) {
            accordionBtn.dispatchEvent(new Event('click'));
        }

        const topPosition = targetElement.getBoundingClientRect().top + window.scrollY - offsetTop;
        window.scrollTo({
            top: topPosition,
            behavior: "smooth"
        });
    }
}

function setupNavLinkHandlers(containerSelector: string, offsets: { default: number, overview: number }): void {
    const navLinks = document.querySelectorAll(`${containerSelector} .nav-link`);
    const handler = handleNavLinkClick(offsets);
    navLinks.forEach(link => {
        link.addEventListener('click', handler);
    });
}

let debounceTimer;
function debouncer(fn, delay = 250) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
        fn();
    }, delay);
}

document.addEventListener('DOMContentLoaded', () => {
    totalNavHeight = updateNavHeight();

    broadcastNavHeight();

    setupNavLinkHandlers('#scroll-nav-mobile', { default: 58, overview: 95 });
    setupNavLinkHandlers('#scroll-nav', { default: 0, overview: 37 });

    window.addEventListener('resize', () => {
        debouncer(() => {
            totalNavHeight = updateNavHeight();
            broadcastNavHeight();
        });
    });

    document.addEventListener('sitewideBannerClosed', () => {
        totalNavHeight = updateNavHeight();
        broadcastNavHeight();
    });
});